import * as React from "react";
import Btn from "@warda/library-ui/core/Btn";
import { deleteNotifJob } from "../../../api/fetchesApiNotifications";
import { ACTION } from "../reducer";
const BtnDelete = ({ dispatch, id, className }) => {
    const [fetch, setFetch] = React.useState(false);
    const [click, setClick] = React.useState(false);
    const onClick = React.useCallback(() => setClick(true), []);
    React.useEffect(() => {
        if (click && !fetch) {
            (async () => {
                try {
                    setFetch(true);
                    await deleteNotifJob(id);
                    dispatch({ type: ACTION.JOB_DELETE_ONE, id });
                }
                catch (err) {
                    console.log("[BtnDelete] error", err);
                }
                setClick(false);
                setFetch(false);
            })();
        }
    }, [click, dispatch, fetch, id]);
    return (React.createElement(Btn, { small: true, className: className, icon: "close", tooltip: "Remove from listing", onClick: onClick }));
};
export default BtnDelete;
